import PageHelper from '../../helpers/page-helper';

export default class QuickAddToCart {

  protected productCode: JQuery;
  protected submit: JQuery;
  protected errorContainer: JQuery;
  protected successContainer: JQuery;
  protected formSubmitted = false;

  constructor(protected form: JQuery) {
    this.productCode = form.find('.js-quick-add-input');
    this.submit = form.find('.js-quick-add-button');
    this.errorContainer = form.find('.js-quick-add-error-container');
    this.successContainer = form.find('.js-quick-add-success-container');
    this.bindValidateProductCodeOnKeyup();
    this.bindSuccessNotificationRemoval();
    this.zoomIntoViewOnError();
    this.disableMultipleFormSubmissions();
    this.productCode.focus();
  }

  bindValidateProductCodeOnKeyup(): void {
    this.productCode.on('keyup', (): void => {

      if (this.form.hasClass('has-error')) {
        this.form.removeClass('has-error');
        this.errorContainer.empty();
      }
      this.productCode.parsley().validate();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  bindSuccessNotificationRemoval(): void {
    if ($('.js-quick-add-success-container').is('*')) {
      setTimeout(() => {
        window.NotificationHelper.clearNotifications();
      }, 3000);
    }
  }

  isValid(): boolean {
    return this.form.parsley().isValid() && !this.form.hasClass('has-error');
  }

  disableMultipleFormSubmissions(): void {
    this.form.on('submit', (e): void => {
      if (this.formSubmitted) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (this.isValid()) {
        this.formSubmitted = true;
        PageHelper.showLoadingIndicator();
      }
    });
  }

  zoomIntoViewOnError(): void {
    if (this.form.hasClass('has-error')) {
      const offset = this.form.offset() as JQuery.Coordinates;
      $('html, body').animate({
        scrollTop: offset.top,
      });
    }
  }
}
